<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import { required } from "vuelidate/lib/validators";
// import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Vue from "vue";
import axios from "axios";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import moment from "moment";
import 'boxicons/css/boxicons.min.css';
import 'boxicons';
// import DatePicker from "vue2-datepicker";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
Vue.component('v-select', vSelect)

// register the plugin on vue
import Toasted from 'vue-toasted';

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Departamento component
 */
export default {
  page: {
    title: "Asignacion Lote Animal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {Layout, Loader,
    // Vuetable,
    VuetablePagination, },
  data() {
    return {
      userT : this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token}
      },
      metododeBusqueda:false,
      fecha_inicio: "",
      rangode_fecha:"",
      fecha_fin:"",
      repit : true,
      fields: [
        {
          name: "lote.no_lote",
          title: "No. Lote",
          sortField: "lote.no_lote",
          width: "20%",
        },
        {
          name: "lote.no_animales",
          title: "No. Animales",
          sortField: "lote.no_animales",
          width: "20%",
        },
        {
          name: "lote.fecha_inicio",
          title: "No. Lote",
          sortField: "lote.fecha_inicio",
          width: "20%",
        },
        {
          name: "tipo_lote",
          title: "Tipo Lote",
          sortField: "tipo_lote",
          width: "20%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
      ],
      apiUrl: process.env.VUE_APP_URL,
      // apiBase: process.env.VUE_APP_URL +"compras/get?tienda=" + this.$store.state.authfack.user.tienda,
      apiBase: process.env.VUE_APP_URL +"concentrado/get" ,
       css: {
      table: {
        tableClass: 'table table-striped table-bordered table-hovered',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      pagination: {
        infoClass: 'pull-left',
        wrapperClass: 'vuetable-pagination pull-right',
        activeClass: 'btn-primary',
        disabledClass: 'disabled',
        pageClass: 'btn btn-border',
        linkClass: 'btn btn-border',
        icons: {
          first: '',
          prev: '',
          next: '',
          last: '',
        },
      }
    },
      formDepa: {
        nombre: "",
        id: 0,
      },
      tiendasData:[],
      updating: false,
      estadotabla:true,
      title:"Asignacion De Alimento ",
      itemst: [
        {
          text: "Asignacion Lote Animal",
          href: "/",
        },
        {
          text: "Lista de Compras de Concentrado",
          active: true,
        },
      ],
   
       searchType: [
        { nombre: "Concentrado", value: "nombre" },
      ],
      options : {
          theme: "outline",  
          position: "top-right", 
          duration : 5000,
          keepOnHover:true,
          action : {
            text : 'X',
            onClick : (e, toastObject) => {
                toastObject.goAway(0);
          },
         
    },
      },
       loadingtable:false,
       sortBy: "nombre",
       sortDesc: false,
       searchLabel: { nombre: "Concentrado", value: "nombre" },
       filterLabel: { nombre: "Concentrado", value: "nombre" },
       showModalL: false, //Loading
       showModalD: false, //Desactivar
       showModalA: false, //Activar
       data:[],
       pageOptions: [4, 10, 15, 20],
       search: "",
        page: 1,
        perPage: 20,
        from: 0,
        to: 0,
        total: 0,
        lastPage: 0,
        arrayAlimento: [],
    };
  },
  validations: {
    formDepa: {
      nombre: { required},
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
        this.getLotes(this.currentPage, this.search);
    }
   
  },
   watch: {
  
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    formatoPresentacion(date) {
      return moment(date).locale("es").format("LL");
    // return moment(date).locale("es").format("LLLL");
    },

    async getLotes(page, search){
        try {
      
        const response = await axios.get(this.apiBase, {
          params: {
            page:page,
            limite: this.perPage,
            search: search
          },
          headers: { "x-token": this.userT.token },
        });
        console.log(response);
        this.arrayAlimento = response.data.data;
        this.onPaginationData(response.data);
        // this.totalItems = response.data.total;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
     customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
     limpiarfiltro(){
        let me = this;
        me.fecha_inicio = "";
        me.fecha_fin = "";
    },
    separarfechas(){
      this.fecha_inicio=this.rangode_fecha[0]
      this.fecha_fin=this.rangode_fecha[1]
    },
  activarBuscadorFechas(search ,index){
      this.metododeBusqueda = (index == 3) ? true : false;
    },
   // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
showDate(date) {
 return moment(date).locale("es").utc().format("MMM Do YYYY");
 },

    //Desactivar registro
  desactivar(){
    const {id } =this.formDepa;
     axios
          .put(process.env.VUE_APP_URL + "compras/desactivate", {
            id: id,
          },{
            headers: { "x-token": this.userT.token}
          })
          .then(() => {
             this.showModalD = false;
             Vue.toasted.error(("Compra Anulada"),this.options);
            //  this.$refs.vuetable.refresh();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
             Vue.toasted.error("Error para desactivar",this.options);
          });
  },
    //Activar registro
  activate(){
     const {id,nombre  } =this.formDepa;
     axios
          .put(process.env.VUE_APP_URL + "departamentos/activate", {
            id: id,
          },{
            headers: { "x-token": this.userT.token}
          })
          .then(() => {
            this.showModalA = false;
            Vue.toasted.info((nombre+" Activado"),this.options);
            // this.$refs.vuetable.refresh();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
             Vue.toasted.error("Error para activar",this.options);
          });
  },


   //Buscador dentro de la tabala
    onFiltered(){
        // console.log('aqui')
      this.search = this.search.toLowerCase();
    //   this.$refs.vuetable.refresh();
    },
   //enviar datos a la Paginacion
   onPaginationData(paginationData) {
    // console.log(paginationData)
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
    //   this.arrayAlimento = this.items;
    // console.log(paginationData.to)
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
        // console.log('aqui')
    //   this.$refs.vuetable.refresh();
        this.getLotes(this.page, this.search);
    },
   async changeTypeDates(){
    // console.log('aqui')
    //   await this.separarfechas()
      // console.log(this.fecha_inicio, this.fecha_fin);
    //   this.$refs.vuetable.refresh();
    this.getLotes(this.page, this.search);
    },
    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
        // console.log(type)
      this.fecha_inicio = (type.value == "fecha") ? '' : ''
      this.fecha_fin = (type.value == "fecha") ? '' : '';
      this.searchLabel = type;
    //   this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
        // console.log(page)
        this.getLotes(page, this.search);
    //   this.$refs.vuetable.changePage(page);

    },
     //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
        // console.log(sortOrder, currentPage)
    
      return sortOrder[0]
        ? {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0] ? sortOrder[0].sortField : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0] ? sortOrder[0].sortField : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
  //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
 openModal(model) {
      switch (model) {
        case "save": {
       this.$v.$reset();
      this.limpiarVariables();
         
      // console.log("entrando a resetear")
          break;
        }
        case "update": {
       this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
limpiarVariables(){
   this.formDepa.id=0;
   this.formDepa.nombre="";
},
 //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
 closeModal(model) {
      switch (model) {
        case "save": {
         this.showModalN=false;
          this.showmodalL = false;
          break;
        }
         case "update": {
           this.showModalE=false;
          this.showmodalL = false;
          break;
        }
      }
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
  
      
     if(action=="desactivate-item"){
        this.formDepa.nombre=data.no_factura_c;
        this.formDepa.id=data.id;
        this.showModalD = true
      }
    
    },
    viewLoteAnimal(id, lote){
      // console.log(lote);
        this.$router.push({ name: 'listado_lotes_concentrado', params: { id: id , nombre_producto: lote.nombre_producto } });
    },
    loteStyle(tipo_lote){
      
      return {
      backgroundColor: tipo_lote === 'engorde' ? '#FFA500' : // Azul para el tipo A
                       tipo_lote === 'inseminacion' ? '#FFA500' : // Verde para el tipo B
                       '#ADD8E6', // Naranja para otros tipos
      color: '#fff', // Texto en blanco
      padding: '20px' // Padding fijo
    };

  
  
    },
    getImagePath(index) {
      
      const images = [
        require('@/assets/cerdos/1.jpeg'),
        require('@/assets/cerdos/2.jpeg'),
        require('@/assets/cerdos/3.jpeg'),
        require('@/assets/cerdos/4.jpeg'),
        require('@/assets/cerdos/5.jpeg'),
        require('@/assets/cerdos/6.jpeg')
      ];
      return images[index % images.length];
    }
    
  },
   computed: {
    ...authComputed,
    ...mapState("authfack", ["status"])
    /**
     * Total no. of records
     */
  
    }
};
</script>
<style>
/* Css para el loading en el modal */
  .my-class{
    background: rgba(255, 255, 255, 0);
    color: white;
    border-bottom: 1px solid #f8f8f800;
    border: 1px solid #c02d2d00;
  }

</style>

<template>
  <Layout>

    <div class="row">
      <div class="col-12">

         <div class="card">
          <div class="card-body">
            <div class="col-12 text-center mb-4">
        <h1 class="list-title">Listado de Alimentos</h1>
      </div>
            <div class="row mt-4">
              


              <div class="container-fluid">
                <div class="header-container mb-4">
      <div class="row align-items-center">
        <div class="col-sm-12 col-md-3">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center w-100">
              Mostrar&nbsp;
              <b-form-select
                class="form-select form-select-lg elegant-select"
                v-model="perPage"
                @input="changePageSize(); getLotes(page, search);"
                size="lg"
                :options="pageOptions"
              ></b-form-select>
            </label>
          </div>
        </div>
        <div class="col-sm-12 col-md-4">
          <div id="tickets-table_length" class="dataTables_length text-md-end">
            <label class="d-inline-flex align-items-center w-100">
              <b-dropdown
                v-if="searchType"
                id="ddown1"
                size="lg"
                class="elegant-dropdown w-100"
              >
                <template v-slot:button-content>
                  {{'Ordenar por: '+ searchLabel.nombre}}
                  <i class="mdi mdi-chevron-down"></i>
                </template>
                <b-dropdown-item
                  v-for="(search, index) in searchType"
                  :key="index"
                  @click="changeTypeSearch(search); getLotes(page, search); activarBuscadorFechas(search, index); limpiarfiltro();"
                >
                  {{ search.nombre }}
                </b-dropdown-item>
              </b-dropdown>
            </label>
          </div>
        </div>
        <div class="col-sm-12 col-md-5 text-md-start">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center w-100">
              <b-form-input
                v-model="search"
                type="search"
                @input="onFiltered(); getLotes(page, search)"
                placeholder="Buscar..."
                class="form-control form-control-lg elegant-input"
              ></b-form-input>
            </label>
          </div>
        </div>
      </div>
    </div>
    <Loader :loading="loadingtable">
                <template>
                  <div class="container-fluid">
                    <div class="row">
                      <div v-for="(lote, index) in arrayAlimento" :key="lote.id" class="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-5">
                        <div class="card larger-card h-100" :style="{ backgroundImage: `url(${getImagePath(index)})` }" @click="viewLoteAnimal(lote.id, lote)">
                          <div class="card-body elegant-card p-5 d-flex flex-column justify-content-center align-items-center">
                            <div class="product-name text-center">
                              {{ lote.nombre_producto }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

            </template>
            <div style="padding-top: 30px">
      <vuetable-pagination
        ref="pagination"
        :css="css.pagination"
        @vuetable-pagination:change-page="onChangePage"
        class="elegant-pagination"
      ></vuetable-pagination>
    </div>
            </Loader>

  </div>
           
              <!-- End search -->
            </div>
            <!-- Table -->
        
          
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
body {
  overflow-y: hidden;
}
.container-fluid.no-scroll {
  overflow: hidden;
}
.list-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #333;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.header-container {
  background: linear-gradient(135deg, #f0f0f0, #d9d9d9);
  padding: 25px;
  border-radius: 25px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}
.elegant-select {
  border-radius: 12px;
  padding: 10px;
  font-size: 1rem;
}
.elegant-dropdown {
  border-radius: 12px;
  padding: 10px;
  font-size: 1rem;
  width: 100%;
  text-align: center;
}
.elegant-input {
  border-radius: 12px;
  padding: 10px;
  font-size: 1rem;
}
.larger-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 30px;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  background-size: cover;
  background-position: center;
  filter: brightness(1.2);
  border: 5px solid #457b9d;
}
.larger-card:hover {
  transform: scale(1.05);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
}
.elegant-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 30px;
}
.product-name {
  background-color: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  padding: 12px;
  border-radius: 12px;
  font-weight: bold;
  font-size: 1.3rem;
  max-height: 5em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.elegant-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  margin-top: 20px;
  padding: 15px;
  background-color: #f0f0f0;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Responsive Styles */
@media (max-width: 768px) {
  .list-title {
    font-size: 2rem;
  }
  .header-container {
    padding: 15px;
  }
  .elegant-select,
  .elegant-dropdown,
  .elegant-input {
    font-size: 0.9rem;
    padding: 8px;
  }
  .larger-card {
    margin-bottom: 20px;
  }
  .product-name {
    font-size: 1rem;
    padding: 8px;
  }
  .elegant-dropdown {
    width: 100%;
    margin-bottom: 10px;
  }
}

@media (max-width: 576px) {
  .list-title {
    font-size: 1.8rem;
  }
  .header-container {
    padding: 10px;
    border-radius: 15px;
  }
  .elegant-pagination {
    font-size: 1.2rem;
    padding: 10px;
  }
  .product-name {
    font-size: 0.9rem;
  }
  .elegant-dropdown {
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }
}

@media (max-width: 992px) and (orientation: landscape) {
  .header-container {
    padding: 20px;
  }
  .larger-card {
    margin-bottom: 15px;
  }
  .elegant-dropdown {
    margin-bottom: 10px;
  }
}

@media (min-width: 1200px) {
  .col-xl-3 {
    flex: 0 0 33.333%;
    max-width: 33.333%;
  }
}
</style>
